<template>
    <x-page :title="pageTitle">
        <template #header-actions>
            <x-back-button :disabled="isLoading" :display-warning="false" />
        </template>

        <translation-upload-batch-form
            id="translation-upload-batch-form"
            v-if="resource"
            :display-id="true"
            :display-join-date="false"
            :displayCode="true"
            :disabled="true"
            :initialFields="resource"
            :readonly="true"
        />
    </x-page>
</template>

<script>
import XBackButton from "../../components/XBackButton.vue";
import XPage from "../../components/XPage.vue";
import XTable from "../../components/XTable.vue";
import TranslationUploadBatchForm from "./TranslationUploadBatchForm.vue";
import PermissionMixin from "../../mixins/PermissionMixin";
import { handleGeneralXhrError } from "../../helpers";

export default {
    components: {
        XPage,
        XBackButton,
        TranslationUploadBatchForm,
        XTable,
    },
    computed: {
        pageTitle() {
            let title = ["Lihat PDF"];

            if (this.resource) {
                title.push(this.resource.display_name);
            }

            return title.join(" | ");
        },
    },
    created() {
        this.fetchResource();
    },
    data() {
        return {
            errors: null,
            isLoading: false,
            resource: null,
        };
    },
    methods: {
        fetchResource() {
            this.isLoading = true;
            const request = axios
                .get(`/api/translation-upload-batches/${this.$route.params.id}`)
                .then((response) => {
                    this.resource = response.data.data;
                });
            return handleGeneralXhrError(request).finally(() => {
                this.isLoading = false;
            });
        },
    },
    mixins: [PermissionMixin],
};
</script>
